import { ProjectSubmission } from "@/javascript/project-objects";
import { Accordion, Button, Group, ScrollArea, Stack, Text, useMantineTheme } from "@mantine/core";
import { useRef } from "react";
import VideoPlayer from "./VideoPlayer";

type VideoModalProps = {
	video: ProjectSubmission,
	videoId: string,
	isOpen: boolean,
	setShowModal: (show: boolean) => void;
};

const VideoModal: React.FC<VideoModalProps> = ({ video, videoId, isOpen, setShowModal }) => {
	const theme = useMantineTheme();
	if (!isOpen) return null;
	console.log(video.instrumenatlistTasks)
	const bottomRef = useRef<HTMLDivElement>(null);

	const scrollToBottom = () => {
		console.log("hi")
		bottomRef.current?.scrollIntoView({ behavior: "smooth" });
	};

	const handleClose = () => {
		setShowModal(false);
	};


	return (
		<Group
			align={"center"}
			justify={"center"}
			style={{
				zIndex: 100000,
				position: "fixed",
				top: 0,
				left: 0,
				width: "100vw",
				height: "100vh",
				backgroundColor: "rgba(0,0,0,0.7)",
				display: "flex",
			}}
			onClick={handleClose}
		>
			<ScrollArea
				w={"80%"}
				h={"90%"}
				style={{
					borderRadius: 25,
					backgroundColor: theme.colors.blue[0],
					boxShadow: "0 2px 16px rgba(0,0,0,0.4)",
					padding: 24,
					position: "relative",
				}}
				onClick={(e) => e.stopPropagation()}
			>
				<Button
					onClick={scrollToBottom}
					pos={"absolute"}
				>
					See Feedback
				</Button>
				<Stack align={"center"} gap="md">
					<VideoPlayer id={videoId} width={"70%"} type="performance" />
				</Stack>
				<Group
					mt={10}
					px={200}
					align="flex-start"
					justify="space-between"
					wrap="nowrap"
					w={"100%"}
				>
					<Stack align="flex-start" w="50%">
						<Text fz={25} pl={10}>
							{video.submissionProjectName}
						</Text>
						<Text fz={20} pl={10}>
							{video.projectOwner?.username}
						</Text>
						<Text fz={20} pl={10}>
							{video.dateFulfilled?.toDateString()}
						</Text>
					</Stack>

					<Stack align="flex-end" w="50%">
						<Accordion w="100%">
							<Accordion.Item value="instrumentalists">
								<Accordion.Control
									bg={theme.colors.blue[7]}
									c={theme.colors.blue[0]}
								>
									Instrumentalists
								</Accordion.Control>
								<Accordion.Panel>
									{video.instrumenatlistTasks.map((task, idx) => (
										<Text key={idx}>{`${task.instrument.name}: ${task.instrumentalist}`}</Text>
									))}
								</Accordion.Panel>
							</Accordion.Item>
							<Accordion.Item value="songs">
								<Accordion.Control
									bg={theme.colors.blue[7]}
									c={theme.colors.blue[0]}
								>
									Songs Used
								</Accordion.Control>
								<Accordion.Panel>

								</Accordion.Panel>
							</Accordion.Item>
						</Accordion>
					</Stack>
				</Group>
				<Stack mt={200} ref={bottomRef} align={"center"} gap="md">
					<VideoPlayer id={videoId} width={"70%"} type="feedback" />
				</Stack>
			</ScrollArea>
		</Group>
	);
};

export default VideoModal;
